<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-04-24 15:46:33
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/my_home_page/index.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <div class="" class="mh-100vh bg-F5F5F5 overflow-hidden border-box pb-20 pt-10 container">

      <swiper ref="mySwiper" @slideChange="slideChange" :options="option" class="home-medical-box">
        <swiper-slide class="benefitBox" v-for="(item, index) in businessCard" :key="index">
          <!-- 卡片 -->
          <MainPageCard :userBaseInfoVo="userBaseInfoVo"></MainPageCard>
          <!-- 按钮 -->
          <MainPageBtn @downLoad='downLoad' :userBaseInfoVo="userBaseInfoVo"></MainPageBtn>
        </swiper-slide>
      </swiper>

    </div>
    <van-overlay :show="loading">
      <van-loading type="spinner" color="#1989fa" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);" />
    </van-overlay>
  </div>
</template>
<script>
import MainPageCard from './components/MainPageCard.vue'
import MainPageBtn from './components/MainPageBtn.vue'
import MainPageIntroduction from './components/MainPageIntroduction.vue'
import MainPageResume from './components/MainPageResume.vue'
import { GetQueryString } from '@/utils/utils'
import { getUserLanguages, queryMyHomePage, shareLinkCreate, toolsShotPro } from '@/api/interNational'
import { translateText } from '@/api/common'
export default {
  name: 'mainPage',
  components: { MainPageCard, MainPageBtn, MainPageIntroduction, MainPageResume },
  data() {
    return {
      loading: false,
      vcardParams: {},
      uid: ``,
      headersNormal: {},
      userBaseInfoVo: {},
      userProfile: {},
      recordVos: [],
      downLoadWord: '',
      saveBusinessCard: '',
      introduceWord: '',
      workExprenice: '',
      isDelete: false,
      successTip: '',
      businessCard: [],
      language: '',
      option: {
        slidesPerView: 1, //显示slide的数量
        centeredSlides: false, //居中显示
        loop: true, //循环
        initialSlide: 0, //初始索引
        spaceBetween: -20, //间距
      },
    }
  },
  mounted() {
    this.$eventBus.$on('infoChange', (res) => {
      this.queryUserHomePageInfo()
    })
    this.queryUserHomePageInfo()
  },
  methods: {
    queryUserHomePageInfo() {
      getUserLanguages({}).then((resp) => {
        console.log(resp)
        this.businessCard = resp.data
        this.language = resp.data[0].language
        this.queryDetail(resp.data[0].language)
      })
    },
    queryDetail(language) {
      queryMyHomePage({}, language).then((res) => {
        if (res.code == 12025) {
          this.isDelete = true
          return false
        }
        this.userBaseInfoVo = res.data.userBaseInfoVo
        this.userProfile = res.data.userProfile
        this.recordVos = res.data.recordVos
      })
    },
    slideChange() {
      let index = this.$refs.mySwiper.swiper.realIndex
      console.log(index)
      let language = this.businessCard[index].language
      this.language = language
      this.queryDetail(language)
    },
    async downLoad() {
      this.loading = true
      try {
        const { data } = await shareLinkCreate()
        console.log(data)
        let token = localStorage.getItem('token')
        let shotUrl = `${process.env.VUE_APP_H5_BASE_URL}/#/poster/myBusinessCard?token=${token}&appKey=WX_MINI_WEMEET&eventKey=WeMeet&uid=${this.userBaseInfoVo.weMeetUid}&showVcard=true&language=${this.language}&shareCode=${data}`
        console.log(shotUrl,'shotUrl')
        let params = {
          url: shotUrl,
          selector: `.group_1`,
        }
        const { data: posterImg } = await toolsShotPro({}, params)
        console.log(posterImg)
        this.loading = false
        const a = document.createElement('a')
        a.href = posterImg
        a.download = 'image.jpg' // 设置下载的文件名
        a.style.display = 'none' // 隐藏元素
        // 将a标签添加到文档中
        document.body.appendChild(a)
        // 触发点击事件
        a.click()
        // 然后移除a标签
        document.body.removeChild(a)
      } catch (err) {
        this.loading = false
      }
    },
  },
}
</script>


<style lang="less">
.home-medical-box {
  .swiper-slide:not(.swiper-slide-active) {
    width: 95%;
  }
}
</style>